import React from "react";
import { useTranslation } from "react-i18next";
import ClipboardIcon from "../icons/heroicons/solid/Clipboard";
import blogIcon from "../../assets/images/blog-icon.png";

const SectionHeader = ({
  name = "",
  eventSection = false,
  seniorLayout = false,
}) => {
  const { t } = useTranslation(); 

  return (
    <div className="flex flex-row items-center gap-2 font-semibold py-4 whitespace-nowrap">
      <img
            src={blogIcon}
            alt="promotion"
            className="object-contain w-6 h-6"
            loading="lazy"
            decoding="async"
          />
      <span className={`text-${seniorLayout ? "2xl" : "base"}`}>
        {t(name)}
      </span>
    </div>
  );
};

export default SectionHeader;
